export default __webpack_public_path__ + "static/media/MedalIcon.3abd1695.svg";